import { gql } from '@apollo/client';
import {
  RestaurantSelect_RestaurantGroupsQuery,
  RestaurantSelect_RestaurantGroupsQueryVariables,
} from '@/types';
import { useEffect, useMemo, useState } from 'react';
import { useWrappedQuery } from './use-wrapped-query';

export const CUSTOMER_GROUP_LIST_FIELDS_FRAGMENT = gql`
  fragment CustomerGroupListFields on restaurant_groups {
    uuid
    name
  }
`;

export const CUSTOMER_GROUP_LIST_QUERY = gql`
  query RestaurantSelect_RestaurantGroups($ownerUUID: uuid!) {
    restaurant_groups(
      order_by: { name: asc }
      where: { owner_uuid: { _eq: $ownerUUID } }
    ) {
      ...CustomerGroupListFields
    }
  }
  ${CUSTOMER_GROUP_LIST_FIELDS_FRAGMENT}
`;

export const useCustomerGroupListQuery = (supplierUUID: string) => {
  const [hasResponse, setHasResponse] = useState(false);

  const queryVariables: RestaurantSelect_RestaurantGroupsQueryVariables =
    useMemo(() => {
      return { ownerUUID: supplierUUID };
    }, [supplierUUID]);

  const { data, error, loading } = useWrappedQuery<
    RestaurantSelect_RestaurantGroupsQuery,
    RestaurantSelect_RestaurantGroupsQueryVariables
  >(CUSTOMER_GROUP_LIST_QUERY, {
    skip: !supplierUUID,
    variables: queryVariables,
  });

  useEffect(() => {
    if (data && !loading) {
      setHasResponse(true);
    }
  }, [data, loading]);

  useEffect(() => {
    // Reset hasResponse when query variables change so the entire table
    // rerenders with the response
    setHasResponse(false);
  }, [queryVariables]);

  return {
    data,
    error,
    hasResponse,
    loading,
  };
};
